import { render, staticRenderFns } from "./ClubDetails.vue?vue&type=template&id=076439ec&scoped=true"
import script from "./ClubDetails.vue?vue&type=script&lang=js"
export * from "./ClubDetails.vue?vue&type=script&lang=js"
import style0 from "./ClubDetails.vue?vue&type=style&index=0&id=076439ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076439ec",
  null
  
)

export default component.exports